import * as R from "ramda";

export function handleApiResponse(res, type = "object", defaultErrMsg = "Something went wrong!") {
    let details = {};
    let apiError = [];
    if (R.pathOr(false, ["status"], res)) {
        const defaultRes = type === "object" ? {} : [];
        details = R.pathOr(defaultRes, ["entity"], res);
    } else {
        apiError = R.pathOr([defaultErrMsg], ["message"], res);
        if (typeof apiError === "string") {
            apiError = [apiError];
        }
    }

    return { details, apiError };
}
